// Stable per-browser anonymous id for guest "try mode".
//
// A logged-out visitor can draw + solve without an account; their solves attach
// to a consistent owner key on the backend (which powers the per-owner active-
// job cap + submission dedup) via the X-Anonymous-Id header. This mirrors the
// scheme the public /api/optimize path already uses. The id is persisted in
// localStorage so it survives reloads, and is sent on every compute request —
// the backend simply ignores it once the visitor is signed in.

const KEY = 'roomtreatment.anon_id';

export function anonId(): string {
  if (typeof window === 'undefined') return '';
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `a-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Private mode / storage disabled — fall back to an ephemeral id so the
    // request still carries a (non-persistent) owner key for this page load.
    return '';
  }
}
